<template>
  <section class="grid-explorer-page" aria-label="Grid Explorer">
    <div class="grid-explorer-shell">
      <header class="grid-explorer-header">
        <div>
          <p class="grid-explorer-kicker">Grid Explorer</p>
          <h1>{{ showActive ? "Active Grids" : "Archived Grids" }}</h1>
        </div>

        <div class="grid-explorer-tabs" role="tablist" aria-label="Grid Explorer views">
          <button
            type="button"
            role="tab"
            :aria-selected="showActive"
            :class="{ active: showActive }"
            @click="showActive = true"
          >
            <span class="material-symbols-outlined" aria-hidden="true">grid_view</span>
            Active
          </button>
          <button
            type="button"
            role="tab"
            :aria-selected="!showActive"
            :class="{ active: !showActive }"
            @click="showActive = false"
          >
            <span class="material-symbols-outlined" aria-hidden="true">archive</span>
            Archived
          </button>
        </div>
      </header>

      <archives :noimport="true" v-if="!showActive" />
      <active-grids v-else />
    </div>
  </section>
</template>

<script>
import Archives from "../../modal-inners/import-inner.vue";
import ActiveGrids from "./active-grids.vue";

export default {
  components: { Archives, ActiveGrids },
  data() {
    return {
      showActive: true,
    };
  },
};
</script>

<style>
.grid-explorer-page {
  width: 100%;
  min-height: calc(100vh - 178px);
  padding: 0.85rem 1rem 2rem;
  color: #172033;
  background: #fff;
}

.grid-explorer-shell {
  width: min(1180px, 100%);
  margin: 0 auto;
}

.grid-explorer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.9rem;
  padding: 0.9rem 1rem;
  border: 1px solid #d9e2ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 10px 24px rgb(15 23 42 / 0.06);
}

.grid-explorer-kicker {
  margin: 0;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.grid-explorer-header h1 {
  margin: 0.1rem 0 0;
  color: #0f172a;
  font-size: 1.35rem;
  font-weight: 900;
}

.grid-explorer-tabs {
  display: inline-flex;
  gap: 3px;
  padding: 3px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #e8eef4;
}

.grid-explorer-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 34px;
  padding: 0 0.75rem;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: #526176;
  font-size: 0.82rem;
  font-weight: 900;
  cursor: pointer;
}

.grid-explorer-tabs button.active {
  background: #fff;
  color: #0b5b70;
  box-shadow: 0 1px 3px rgb(15 23 42 / 0.12);
}

.grid-explorer-tabs .material-symbols-outlined {
  font-size: 19px;
}

@media (max-width: 700px) {
  .grid-explorer-page {
    min-height: calc(100vh - 168px);
    padding: 0 0 1.5rem;
  }

  .grid-explorer-header {
    align-items: stretch;
    flex-direction: column;
    margin: 0 0 0.75rem;
    padding: 0.85rem 0.9rem;
    border-right: 0;
    border-left: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .grid-explorer-tabs {
    width: 100%;
  }

  .grid-explorer-tabs button {
    flex: 1;
    justify-content: center;
  }
}
</style>
